import * as React from 'react'
import { connect } from 'react-redux'

import { togglePanel } from '../../../../../common/actions/layout'
import { reportFilterToggle } from '../../../../../common/analytics/filtersAnalytics'
import { IRootState } from '../../../../../common/reducers'
import { hasFeature } from '../../../../../common/utils/features'
import FilterPanel from './'

interface IStateProps {
  expanded: boolean
}

interface IDispatchProps {
  dispatch?: any
}

interface IOwnProps {
  children: React.ReactNode
  id: string
  title: string
}

const mapStateToProps = (
  state: IRootState,
  ownProps: IOwnProps
): IStateProps => {
  const {
    layout: { toggledPanelIds },
    common: { currentSite },
    router: { location },
    experiments
  } = state

  const shouldCollapseFilters = hasFeature(
    'filters:collapsed',
    currentSite,
    location,
    experiments
  )

  const filterSelected = toggledPanelIds.indexOf(ownProps.id) < 0
  const expanded = shouldCollapseFilters ? !filterSelected : filterSelected

  return { expanded }
}

const mapDispatchToProps = (dispatch: any) => {
  return { dispatch }
}

const mergeProps = (
  stateProps: IStateProps,
  dispatchProps: IDispatchProps,
  ownProps: IOwnProps
) => {
  const { dispatch, ...restDispatch } = dispatchProps

  return {
    ...ownProps,
    ...stateProps,
    ...restDispatch,
    togglePanel: (panelId: string) => {
      reportFilterToggle(ownProps.id, stateProps.expanded)
      dispatch(togglePanel(ownProps.id))
    }
  }
}

const PanelContainer = connect<IStateProps, IDispatchProps, IOwnProps>(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(FilterPanel)

export default PanelContainer
